// extracted by mini-css-extract-plugin
module.exports =  {"root":"E8QKogMZmxeUtRYnX4oR","icon":"E_ZkjyfhLEuoO3Dwh219"};